import React from "react";
import { MapPinIcon, HomeIcon } from "lucide-react";
import Loading from "../../components/Loading";

// Define fields with dynamic icons
const fields = [
  {
    key: "Name",
    label: "Id",
  },
  {
    key: "Request_For",
    label: "Request For",
  },
  {
    key: "Status",
    label: "Status",
  },
  {
    key: "Request_details",
    label: "Request Details",
  },
  {
    key: "Rejection_Remarks",
    label: "Rejection Remarks",
  },
  {
    key: "Approved_Remarks",
    label: "Approved Remarks",
  },
];

const ChangeRequestList = ({ isLoading, orders, setSearchValues }) => {

  const handleApiCall = (selectedValue) => {
    setSearchValues((searchValues) => {
      return {
        ...searchValues,
        ["Stage"]: selectedValue,
        page: 1,
      };
    });
    // console.log("Selected value:", selectedValue);
  };

  
  return (
    <div className="overflow-x-auto">
      <table className="min-w-full text-sm text-left text-gray-500 dark:text-gray-400">
        <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
          <tr>
            {fields.map((field) => (
              <th
                key={field.key}
                scope="col"
                className="px-6 py-3 font-semibold text-center"
              >
                <div className="items-center">
                  {field.icon && <field.icon className="inline mr-2 h-4 w-4" />}
                  {field.label === "Status" ? (
                    // <select
                    //   className="p-1 text-center border-0 focus:outline-0 focus:ring-0 focus:border-transparent text-sm bg-gray-50"
                    //   onChange={(e) => handleApiCall(e.target.value)}
                    // >
                    //   <option value="">Select Status</option>
                    //   {/* You can add your stage options here */}
                    //   <option value="Pending for Approval">Pending for Approval</option>
                    //   <option value="Approved">Approved</option>
                    //   <option value="Rejected">Rejected</option>
                    // </select>
                    <input
                      className="w-[100px] border border-gray-300 rounded-md p-1 px-2"
                      onChange={(e) => handleApiCall(e.target.value)}
                      placeholder="Status"
                    />
                  ) : (
                    field.label
                  )}
                </div>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {isLoading ? (
            <tr>
              <td colSpan={6} className="text-center">
                <Loading />
              </td>
            </tr>
          ) : orders?.length > 0 ? (
            orders.map((data) => (
              <tr
                key={data.id}
                className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600"
              >
                {fields?.map((field) => (
                  <td
                    key={field.key}
                    className={`${
                      field.key === "Status"
                        ? `flex h-fit items-center justify-center gap-1 mt-3 text-center font-semibold 
                          ${
                            data[field.key] === "Approved"
                              ? "bg-green-100 text-green-800 group-hover:bg-green-200 dark:bg-green-200 dark:text-green-800 dark:group-hover:bg-green-300"
                              : data[field.key] === "Rejected"
                              ? "bg-red-100 text-red-800 group-hover:bg-red-200 dark:bg-red-200 dark:text-red-800 dark:group-hover:bg-red-300"
                              : "bg-cyan-100 text-cyan-800 group-hover:bg-cyan-200 dark:bg-cyan-200 dark:text-cyan-800 dark:group-hover:bg-cyan-300"
                          }
                          p-1 text-xs rounded px-2 py-1 shadow-md`
                        : "px-6 py-4 break-words text-center"
                    }`}
                  >
                    {data[field.key] || "N/A"}
                  </td>
                ))}
              </tr>
            ))
          ) : (
            <tr>
              <td
                colSpan={fields.length}
                className="px-6 py-4 text-center text-gray-500"
              >
                No data available
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default ChangeRequestList;
